/// <reference path="./global.d.ts" />
/*!
 * @preserve
 * IPv6Test.js
 * JS-Bestandteil des IPv6-Test (BrowserInfoCollector Contao Modul / dein-ip-check.de)
 *
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import {searchIpWhois} from "./lib/searchIpWhois.library";
import {map, searchIpGeo} from "./lib/searchIpGeo.library";

require('es6-promise').polyfill();

window.onload = () => {
    // Clipboard-Unterstützung aktivieren
    searchIpWhois.initClipboard();
    
    // Falls direkt beim Seitenaufruf die Karte bereits existiert, diese initialisieren zusammen
    if($('#map').length) {
        searchIpGeo.initMap('map');

        // noinspection JSJQueryEfficiency
        let longitude: number = parseFloat($("#longitude").data("js")),
            latitude: number = parseFloat($("#latitude").data("js")),
            accuracyRadius: number = parseFloat($("#accuracyRadius").data("js"));

        if (typeof longitude !== 'number' || typeof latitude !== 'number' || typeof accuracyRadius !== 'number') {
            // Ungültige Angaben - ersetze angezeigte Werte durch die Default-Werte
            longitude = 51.165000;
            // noinspection JSNonASCIINames
            $("#longitude").text(`${longitude} ${longitude > 0 ? DETECTPHRASE['Nord'] : DETECTPHRASE['Süd']}`);
            latitude = 10.455278;
            $("#latitude").text(`${latitude} ${latitude > 0 ? DETECTPHRASE['Ost'] : DETECTPHRASE['West']}`);
            accuracyRadius = 100;
            $("#accuracyRadius").text(accuracyRadius + ' km');
        }

        // Setze Position
        searchIpGeo.setPosition(longitude, latitude, accuracyRadius);

        // Whois-Click Event initialsieren
        searchIpWhois.initWhoisIP("#ipwhois");
    } 

    // Suche starten
    $('#ipSearchForm #ctrl_submit').on('click', a => {
        const punycode = require('punycode');
        const isValidIp = require('is-ip');
        const isValidDomain = require('is-valid-domain');
        
        // Welche IP wurde eingegeben?
        let clientIP = $('#ip');

        // Wandle Eingabe in Punycode um
        let puttyCodeHostname = null;
        try {
            // PunnyCode für Umlaut-Domain erzeugen
            puttyCodeHostname = punycode.toASCII(clientIP.val().toString());
            
            // Sofern die Benutzereingabe korrigiert wurde, diese übergeben an das Eingabefeld
            if(puttyCodeHostname !== clientIP.val().toString()) {
                clientIP.val(puttyCodeHostname);
            }
        } catch (e) {
            console.error('Hostname-to-ASCII conversation failed: ' + e.toString());
        }

        // Prüfe auf brauchbare Eingabe
        if(isValidIp(clientIP.val().toString())) {
            // Gültige IP gefunden
            searchIpGeo.startAjaxRequest(clientIP.val().toString());
        } else if(isValidDomain(puttyCodeHostname)) {
            // Gültiger Hostname gefunden
            searchIpGeo.startAjaxRequest(puttyCodeHostname);
        } else {
            // Weder Hostname oder IP gefunden
            // noinspection JSNonASCIINames
            let result = "<div class='alert alert-danger text-center' role='alert'><div id='errorText'>" +
                DETECTPHRASE['Bei der angegebenen Adresse handelt es sich um keine gültige IPv4 oder IPv6-Adresse oder Hostname.']
                + "</div></div>";
            $('#ipSearchResult').html(result);
            console.error("FormError: Invalid IPv4, IPv6 adress or hostname");

            // Ergebnis in History legen
            history.pushState(
                {"ip": clientIP.val().toString(), 'longitude': null, 'latitude': null, 'accuracyRadius': null, 'html': result},
                null, searchIpGeo.getPostURL()
            );
        }
        a.preventDefault();
    });
};

/**
 * History Event-Handler
 */
window.addEventListener('popstate', function (e) {
    if (e.state === null || e.state.html === "") {
        // Leeres Formular erzeugen
        $('#ipSearchResult').html("");
        $('#ip').val("");
    } else {
        // Seiteninhalt aus der History aktualisieren
        $('#ip').val(e.state.ip);
        $('#ipSearchResult').html(e.state.html);
                
        if (e.state.longitude !== null && e.state.latency !== null && e.state.acceleration !== null) {
            searchIpGeo.initMap('map');
            searchIpGeo.setPosition(e.state.longitude, e.state.latitude, e.state.accuracyRadius);
        }
    }
});
